import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=115f5dbd&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=115f5dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115f5dbd",
  null
  
)

export default component.exports